import { algoliasearch } from 'algoliasearch';

export default class AlgoliaSearch {
    constructor(indexName = 'products_query_suggestions') {
        this.appId = import.meta.env.VITE_ALGOLIA_APP_ID;
        this.apiKey = import.meta.env.VITE_ALGOLIA_APP_KEY;
        this.indexName = indexName;
        
        if (this.appId && this.apiKey) {
            this.client = algoliasearch(this.appId, this.apiKey);
        }
    }

    /**
     * Fetch search suggestions from Algolia
     * @param {string} query The search input
     * @param {number} limit Maximum number of suggestions to return
     * @returns {Promise<string[]>} List of suggestion strings
     */
    async getSuggestions(query, limit = 5) {
        if (!query || !query.trim() || !this.client) {
            return [];
        }

        try {
            const { results } = await this.client.search({
                requests: [
                    {
                        indexName: this.indexName,
                        query: query,
                        hitsPerPage: limit
                    }
                ]
            });
            
            if (results && results.length > 0) {
                return results[0].hits
                    .map(hit => hit.query || hit.name || hit.title || "")
                    .filter(val => typeof val === "string" && val.trim() !== "")
                    .slice(0, limit);
            }
            
            return [];
        } catch (error) {
            console.error("Error fetching suggestions from Algolia:", error);
            return [];
        }
    }
}
